// extracted by mini-css-extract-plugin
export var sidebar = "MobileNavbar-module--sidebar--1uAiG";
export var socialLinksGroup = "MobileNavbar-module--social-links-group--12VNt";
export var socialLink = "MobileNavbar-module--social-link--1u4sS";
export var closeMobileMenuIcon = "MobileNavbar-module--close-mobile-menu-icon--3pxrC";
export var collapse = "MobileNavbar-module--collapse--2TebR";
export var active = "MobileNavbar-module--active--S7N5Q";
export var mobileNavBar = "MobileNavbar-module--mobile-nav-bar--1xxBN";